import endpoints from "../constants/env/middletier";

import React, {useEffect, useRef, useState} from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { Tooltip } from 'primereact/tooltip';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { InputText } from "primereact/inputtext";
import {useAuth} from "../AuthProvider";

export default function FileUploadPageCustom() {
    const toast = useRef(null);
    const fileUploadRef = useRef(null);
    const [cxProjects, setCxProjects] = useState(null);
    const [logs, setLogs] = useState(null);
    const [logLookup, setLogLookup] = useState(null);
    const [selectedLog, setSelectedLog] = useState(null);
    const [visible, setVisible] = useState(false);
    const [filters, setFilters] = useState({
        logType: { value: null, matchMode: FilterMatchMode.EQUALS }
    });
    const [logTypes] = useState(['ISSUE', 'ERROR']);
    const { keycloak } = useAuth()

    const fetchLogLookup = async () => {
        try {
            await keycloak.updateToken(30);

            // const logResponse = await fetch(`${endpoints.ingestionloglookup}`, {
            // // const logResponse = await fetch(Endpoints["ingestionloglookup"], {
            //     method: "GET"
            // });

            const logResponse = await fetch(`${endpoints.ingestionloglookup}`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!logResponse.ok) {
                throw new Error("Loglookup: Bad response");
            }

            const logLookupData = await logResponse.json();
            setLogLookup(logLookupData);
        } catch (error) {
            console.error("Failed to fetch log lookup:", error);
        }
    };

    useEffect(() => {
        fetchLogLookup();
    }, []);

    const getSeverity = (status) => {
        switch (status) {
            case 'ERROR':
                return 'danger';

            case 'INFO':
                return 'success';

            case 'ISSUE':
                return 'info';
        }
    };
    const logTypeItemTemplate = (option) => {
        return <Tag value={option} severity={getSeverity(option)} />;
    };

    const logTypeRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={logTypes} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={logTypeItemTemplate} placeholder="Select One" className="p-column-filter" showClear style={{ minWidth: '12rem' }} />
        );
    };

    function formatDate(dateString) {
        const date = new Date(dateString);

        const datePart = new Intl.DateTimeFormat("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric"
        }).format(date);

        const timePart = new Intl.DateTimeFormat("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        }).format(date);

        return `${datePart} ${timePart}`;
    }

    const onTemplateUpload = async (e) => {
        const uploadFile = e.files[0];

        if (!uploadFile) {
            return;
        }

        const formData = new FormData();
        formData.append("file", uploadFile);

        try {
            // Upload workbook.  Store the response (cxProject) in a local variable
            const response = await fetch(`${endpoints.upload}`, {
            // const response = await fetch(Endpoints["upload"], {
                method: "POST",
                body: formData,
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                }
            });

            if (!response.ok) {
                throw new Error(`Upload failed: ${response.status}`);
            }

            const result = await response.text();
            console.log(result);
            // const result = await response.json();
            // setCxProjects([result]);

            // const logResponse = await fetch(`${endpoints.ingestionloglookup}`, {
            // // const logResponse = await fetch(Endpoints["ingestionloglookup"], {
            //     method: "GET"
            // });

            const logResponse = await fetch(`${endpoints.ingestionloglookup}`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!logResponse.ok) {
                throw new Error("Loglookup: Bad response");
            }

            const logLookupData = await logResponse.json();
            setLogLookup(logLookupData);
        } catch (err) {
            console.error(err);
        } finally {
            fileUploadRef.current?.clear();
        }

        toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
    };


    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-file-excel mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Drag and Drop Cx Workbook Here
                </span>
            </div>
        );
    };


    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.logType} severity={getSeverity(rowData.logType)} />;
    };

    return (
        <>
            <div className="card flex justify-content-center">

                <Dialog header="Imported Project Data" maximizable visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
                    {cxProjects && (
                        <div className="card">
                            <DataTable value={logs} tableStyle={{ minWidth: '50rem' }} filters={filters} filterDisplay="row">
                                <Column field="logType" header="Log Type" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                        style={{ minWidth: '12rem' }} filter filterElement={logTypeRowFilterTemplate} body={statusBodyTemplate} />
                                <Column field="logEntity" header="Entity"></Column>
                                <Column field="logContent" header="Log Data"></Column>
                            </DataTable>
                            <br />
                            <br />
                            <br />
                        </div>
                    )}
                </Dialog>
            </div>

            <Card title="Import Commissioning Workbook">
                <Toast ref={toast}></Toast>
                {cxProjects && (
                    <Button label="Show Preview" text icon="pi pi-external-link" onClick={() => setVisible(true)} />
                )}
                <Tooltip target=".custom-choose-btn" content="Choose Workbook" position="bottom" />
                <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
                <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

                <FileUpload ref={fileUploadRef} name="demo[]" url={'/upload/excel'} accept="*/*" maxFileSize={100000000}
                            emptyTemplate={emptyTemplate} customUpload uploadHandler={onTemplateUpload} />

            </Card>

            <div className="flex align-items-center flex-column">


            </div>
        </>

    )
}
